<template>
  <div class="">
    <div class="tab__header">
      <div v-if="type !== '2'" class="accordion-title">
        <button
          type="button"
          class="btn btn-link ml-2 f-size-14"
          @click.prevent="active = !active"
        >
          <strong class="ml-1">{{ title }}</strong>
          <span class="down-Arrow" v-show="!active">&#9660;</span>
          <span class="up-Arrow" v-show="active">&#9650;</span>
        </button>
      </div>
      <div v-else class="accordion-title">
        <button
          type="button"
          class="btn btn-link w-100 bg-blue white text-left accordion-type-2"
          @click.prevent="active = !active"
        >
          <div class="row">
            <strong class="col-10 col-md-11">{{ title }}</strong>
            <span class="down-Arrow col-1 text-right" v-show="!active">
              &#9660;
            </span>
            <span class="up-Arrow col-1 text-right" v-show="active">
              &#9650;
            </span>
          </div>
        </button>
      </div>
    </div>
    <div v-show="active"><slot /></div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: ['title', 'type'],
  data() {
    return {
      active: false,
    }
  },
  methods: {
    setDisplay(mode) {
      this.active = mode
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.accordion-type-2
  text-decoration: none
  height: 60px
  &:hover
    color: white
    text-decoration: none
    opacity: 0.8
.accordion-title
  @include sp
    width: 95%
    margin: 0 auto
</style>



// WEBPACK FOOTER //
// src/components/utils/Accordion.vue